module.exports = __webpack_public_path__ + "img/dummyprod11@1x.5ad16249.png";